/* eslint-disable camelcase */
import {
    IS_SUBMITTING_CHECKOUT,
    IS_SUBMITTING_PROMOCODE,
    RESET_CHECKOUT,
    SET_CHECKOUT_COMPLETE,
    SET_CHECKOUT_DELIVERY_DATES,
    SET_CHECKOUT_EXCLUDED_PICKERS,
    SET_CHECKOUT_MESSAGE,
    SET_CHECKOUT_PAYMENT_VALID,
    SET_CHECKOUT_VALIDATION,
    SET_ORDER_ADDRESS,
    TOGGLE_CHECKOUT_ERRORS_VISIBILITY,
} from 'reducers/actions-types';
import { defaultErrors, validate } from './helpers';

export default function checkoutReducer(
    /** @type {ICheckoutState} */
    state = {
        isValid: false,
        isComplete: false,
        areErrorsVisible: false,
        isSubmitting: false,
        isUpdatingAddresses: false,
        excluded_pickers: [],
        errors: defaultErrors,
        additional_info: '',
        delivery_start_date: null,
        delivery_end_date: null,
        address_id: null,
        isPaymentMethodValid: false,
        isSubmittingPromo: false,
    }, payload) {
    const {
        type,
        additional_info,
        addressId,
        delivery_start_date,
        delivery_end_date,
        isSubmitting,
        isComplete,
        excluded_pickers,
        areErrorsVisible,
        isPaymentMethodValid,
        isSubmittingPromo,
        validationState,
    } = payload;
    const validateCheckout = () => validate(Object.assign({}, state, payload));

    switch (type) {
        case RESET_CHECKOUT:
            return Object.assign({}, state, {
                isValid: false,
                errors: defaultErrors,
                isComplete: false,
                isSubmitting: false,
                areErrorsVisible: false,
                isUpdatingAddresses: false,
                additional_info: '',
                excluded_pickers: [],
                delivery_start_date: null,
                delivery_end_date: null,
                address_id: null,
            });
        case TOGGLE_CHECKOUT_ERRORS_VISIBILITY:
            return Object.assign({}, state, { areErrorsVisible });
        case IS_SUBMITTING_PROMOCODE:
            return Object.assign({}, state, { isSubmittingPromo });
        case SET_CHECKOUT_PAYMENT_VALID:
            return Object.assign({}, state, { isPaymentMethodValid }, validateCheckout());
        case SET_CHECKOUT_EXCLUDED_PICKERS:
            return Object.assign({}, state, { excluded_pickers: [...excluded_pickers] });
        case SET_CHECKOUT_MESSAGE:
            return Object.assign({}, state, { additional_info });
        case SET_CHECKOUT_VALIDATION:
            return Object.assign({}, state, validationState);
        case IS_SUBMITTING_CHECKOUT:
            return Object.assign({}, state, { isSubmitting });
        case SET_CHECKOUT_COMPLETE:
            return Object.assign({}, state, { isComplete });
        case SET_ORDER_ADDRESS:
            return Object.assign({}, state, { address_id: addressId }, validateCheckout());
        case SET_CHECKOUT_DELIVERY_DATES:
            return Object.assign({}, state, {
                delivery_start_date,
                delivery_end_date,
            }, validateCheckout());
        default:
            return state;
    }
};



// WEBPACK FOOTER //
// ./mcart/assets/src/js/app/reducers/modules/checkout/index.js